import React from 'react';
import {useSelector} from 'react-redux';
import {NavLink, NavLinkProps} from 'react-router-dom';
import {List, ListItem} from '@material-ui/core';
import {useStyles} from './styles';
import {INavLink} from './typedef';
import {links} from './links';
import {authSelector} from '../../../auth/selectors';

const navLink = (link: INavLink) => {
    const {name, url, exact = false, icon} = link;
    const WrappedLink = React.forwardRef<any, Omit<NavLinkProps, 'to'>>(function Link(props, ref) {
        const classes = useStyles();
        return (
            <NavLink exact={exact} activeClassName={classes.active} to={url} {...props}>
                {icon ? <img src={icon} alt={name} className={classes.menuIcon} /> : null}
                {name}
            </NavLink>
        );
    });
    return WrappedLink;
};

const linksComponents = links.map((link: INavLink) => {
    return {
        title: link.title,
        component: navLink(link),
        roles: link.roles
    };
});

const SidebarMenu = () => {
    const classes = useStyles();
    const {user} = useSelector(authSelector);

    if (!user) {
        return null;
    }
    return (
        <List component="nav" className={classes.root}>
            {linksComponents.map((link) => {
                return user.roles.some((role) => link.roles.includes(role)) ? (
                    <ListItem key={link.title} component={link.component} className={classes.normal} />
                ) : null;
            })}
        </List>
    );
};

export const SidebarMenuComponent = SidebarMenu;
